var exports = {
  "menu_button": "xdbfd91f1--477e29--menu_button",
  "title": "xdbfd91f1--477e29--title",
  "icon-photo": "xdbfd91f1--477e29--icon-photo",
  "icon-video": "xdbfd91f1--477e29--icon-video",
};

module.exports = exports;
